class Claim {
  constructor() {
    this.blocks = document.querySelectorAll('[data-shortcode="claim"]');

    if (0 !== this.blocks.length) {
      this.blocks.forEach(block => {
        new Controller(block);
      });
    }
  }
}
class Controller {
  constructor(block) {
    this.el = $(block);
    this.id = this.el.data('id');

    this.triggers = {
      claim: this.el.find('[data-trigger="claim"]'),
      unclaim: this.el.find('[data-trigger="unclaim"]'),
      change: this.el.find('[data-trigger="change"]'),
    }

    this.state = '';
    this.private = true;

    this.initEvents();

    setTimeout(() => {
      this.initData();
    }, 5000);
  }

  async initData() {
    const result = await $.ajax({
      url: window.bvm.ajax,
      method: 'POST',
      data: {
        action: 'bvm_claim_get_ownership',
        id: this.id,
      },
    });

    if (result.success) {
      this.state = result.data.state;
      this.private = result.data.private;
    }

    $(document).trigger('bvm_shortcode_claim_initialized', this.el);
  }

  initEvents() {
    $(document).on('bvm_shortcode_claim_initialized', (e, el) => {
      if (this.el.is($(el))) {
        this.initTriggers();
      }
    });
  }

  initTriggers() {
    this.el.fadeOut();

    this.triggers.unclaim.hide();
    this.triggers.change.hide();
    this.triggers.claim.hide();

    this.triggers.claim.on('click', () => {
      this.triggerClaim();
    });

    this.triggers.unclaim.on('click', () => {
      this.triggerUnclaim();
    });

    this.triggers.change.on('click', () => {
      this.triggerChange();
    });

    switch (this.state) {
      case 'owned':
        this.triggers.unclaim.show();
        break;

      case 'occupied':
        this.triggers.change.show();
        break;

      case 'unoccupied':
        this.triggers.claim.show();
        break;
    }

    this.el.fadeIn();
  }

  /**
   * @legacy
   */
  triggerClaim() {
    if (! this.private) {
      jQuery('#loginModal').trigger('modalOpen');
    } else {
      jQuery('#claimTeamModal').trigger('modalOpen');
    }
  }

  /**
   * @legacy
   */
  triggerUnclaim() {
    if (! this.private) {
      jQuery('#loginModal').trigger('modalOpen');
    } else {
      jQuery('#unclaimTeamModal').trigger('modalOpen');
    }
  }

  /**
   * @legacy
   */
  triggerChange() {
    if (! this.private) {
      jQuery('#loginModal').trigger('modalOpen');
    } else {
      jQuery('#claimTeamModal').trigger('modalOpen');
    }
  }
}

export default Claim;
